import { Userpilot } from "userpilot";

export type TApiUserpilotConfig = {
    clientToken: string;
    // Free-form environment label, used as an id prefix and analytics tag.
    environment: string;
    appURL: string;
    // Whether Userpilot should be initialised (third-party tools enabled).
    enabled: boolean;
};

export type TApiUserpilot = ReturnType<typeof createApiUserpilot>;

export const createApiUserpilot = ({
    clientToken,
    environment,
    appURL,
    enabled,
}: TApiUserpilotConfig) => ({
    setUser: (params: {
        id: string;
        companyId: number;
        companyName: string;
        userEmail: string;
        isProdaUser: boolean;
        isGlobalAdmin: boolean;
    }) => {
        if (!enabled) {
            console.debug(
                "Skipping Userpilot identify: third-party tools are disabled.",
            );
            return;
        }
        const idPrefix = environment;
        const userPilotId = `${idPrefix}${params.id}`;
        const userEmailDomain = params.userEmail.split("@")[1]?.toLowerCase();
        Userpilot.identify(userPilotId, {
            name: params.userEmail,
            email: params.userEmail,
            user_id: params.id,
            global_admin: params.isGlobalAdmin,
            email_domain: userEmailDomain,
            is_proda_user: params.isProdaUser,
            proda_user_email: params.isProdaUser
                ? params.userEmail
                : "not_proda_user",
            company: {
                id: `${idPrefix}${params.companyId}`,
                name: params.companyName,
            },
            app_url: appURL,
            environment,
        });
    },
    initUserpilot: () => {
        if (!enabled) {
            console.debug(
                "Skipping Userpilot init: third-party tools are disabled.",
            );
            return;
        }
        Userpilot.initialize(clientToken);
    },
});
